import { GitBranchIcon } from '@phosphor-icons/react';

interface SessionHeaderFactsProps {
  title: string;
  repo: string;
  /** The branch shown beside the repo — the working branch, or a plan's base branch. */
  branch: string | null;
}

/** Title, repository and branch chips that open both session headers (the code view and the plan view). */
export function SessionHeaderFacts({ title, repo, branch }: SessionHeaderFactsProps) {
  return (
    <>
      <span className="max-w-105 truncate text-sm font-semibold text-fg" title={title}>
        {title}
      </span>
      <span
        className="max-w-55 truncate rounded-md border border-line bg-surface-3 px-2 py-1 text-2xs text-fg-secondary"
        title={repo}
      >
        {repo}
      </span>
      {branch && (
        <span className="flex items-center gap-1 rounded-md border border-line bg-surface-3 px-2 py-1 font-mono text-2xs text-fg-secondary">
          <GitBranchIcon size={12} />
          {branch}
        </span>
      )}
    </>
  );
}
